import { Component, inject, signal } from "@angular/core";
import { NavBarService } from "@app/layouts/nav-bar/nav-bar.service";
import { LogoComponent } from "@app/layouts/nav-bar/title-nav-bar/logo/logo.component";
import { environment } from "@env/environment";
import { DxSharedModule } from "@app/shared/dx-shared.module";
import { CdkCopyToClipboard } from "@angular/cdk/clipboard";

@Component({
  selector: "app-title-nav-bar",
  standalone: true,
  imports: [LogoComponent, DxSharedModule, CdkCopyToClipboard],
  templateUrl: "./title-nav-bar.component.html",
  styleUrl: "./title-nav-bar.component.scss",
  host: {
    "[class.minimized]": "isMinimized()",
  },
})
export class TitleNavBarComponent {
  public version = environment.version;
  protected versionCopied = signal<boolean>(false);
  private readonly navService = inject(NavBarService);
  protected readonly isMinimized = this.navService.getSignalIsMinimized();

  protected onMinimized(): void {
    this.navService.toggleIsMinimized();
  }

  protected onCopied(success: boolean): void {
    if (success) {
      this.versionCopied.set(true);
      setTimeout(() => this.versionCopied.set(false), 1000);
    }
  }
}
